import { ReactNode } from 'react';
import styled from 'styled-components';
import { DisableSelection } from '../../../styles/stylesStyled';

interface ButtonProps {
  negative?: boolean;
  fs?: string;
  darkFont?: string;
  h?: string;
  p?: string;
  condensed?: boolean;
  textButton?: boolean;
  w?: string;
  wSM?: string;
  maxWidth?: string;
  maxWidthSM?: string;
  m?: string;
  ml?: string;
  mr?: string;
  mt?: string;
  mb?: string;
  mSM?: string;
  mlSM?: string;
  mrSM?: string;
  mtSM?: string;
  mbSM?: string;
  disabled?: boolean;
  children?: ReactNode;
  textColor?: string;
}

export const Button = styled.button<ButtonProps>`
  border: none;
  font-size: 15px;
  font-weight: 500;
  color: #fff;
  height: 44px;

  width: ${({ w }) => (w ? w : '100%')};
  cursor: pointer;

  font-size: ${(props) => props.theme.buttonFontSize};

  color: ${(props) =>
    props.negative
      ? props.theme.buttonNegativeFontColor
      : props.theme.buttonFontColor};

  ${(props) => props.textColor && `color: ${props.textColor};`}

  background-color: ${(props) =>
    props.negative
      ? props.theme.buttonNegativeBackground
      : props.theme.buttonBackground};

  ${({ color }) => color && `background-color: ${color}`};

  border: ${(props) =>
    props.negative ? props.theme.buttonNegativeBorder : 'none'};

  ${({ color }) => color && `background-color: ${color}`};

  ${(props) =>
    props.disabled && `color: ${props.theme.buttonDisabledFontColor};`}

  ${(props) =>
    props.disabled && `background: ${props.theme.buttonDisabledBackground};`}

  ${(props) => props.disabled && `opacity: 0.5;`}

  ${(props) => props.disabled && `border: ${props.theme.buttonDisabledBorder};`}

  ${(props) => props.disabled && `cursor: not-allowed`};

  ${(props) => props.fs && `font-size: ${props.fs}`};

  ${(props) => props.darkFont && `color: ${props.theme.colors.neutral50};`}

  border-radius: ${(props) => props.theme.buttonBorderRadius};

  height: ${(props) => props.h};
  padding: ${(props) => props.p};

  /* border: none; */

  margin: ${(props) => props.m};
  margin-top: ${(props) => props.mt}px;
  margin-bottom: ${(props) => props.mb}px;
  margin-left: ${(props) => props.ml}px;
  margin-right: ${(props) => props.mr}px;

  max-width: ${(props) => props.maxWidth};

  ${({ condensed }) =>
    condensed &&
    `
    height: 33px; 

  `}

  @media (max-width: 800px) {
    margin: ${(props) => props.mSM};
    margin-top: ${(props) => props.mtSM}px;
    margin-bottom: ${(props) => props.mbSM}px;
    margin-left: ${(props) => props.mlSM}px;
    margin-right: ${(props) => props.mrSM}px;

    max-width: ${(props) => props.maxWidthSM};
    width: ${(props) => (props.wSM ? props.wSM : '100%')};
  }

  ${({ textButton, theme }) =>
    textButton &&
    `
    background-color: rgba(0,0,0,0);
    color: ${theme.colors.primary900};
    font-weight: 500;
    border: none;
  `}

  ${({ textButton, theme, disabled }) =>
    textButton &&
    disabled &&
    `
    color: ${theme.colors.neutral500};
  `}

  transition: transform 0.1s ease, background-color 0.3s ease, border 0.3s ease,
    color 0.3s ease;

  :active {
    transform: translateY(3px);
  }
  > * {
    ${DisableSelection}
  }
`;
